<template>
  <el-scrollbar>
    <label style="margin-left: 5px;font-weight: bold">员工信息:</label>
    <el-card style="margin: 5px">
      <el-form :model="employeeData" label-width="140px">
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item label="工号：" required>
                  <el-input v-model="employeeData.employee_no" placeholder="工号"
                            oninput="value=value.replace(/[^\d]/g, '')" disabled clearable/>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="姓名：" required>
                  <el-input v-model="employeeData.employee_name" placeholder="姓名" disabled clearable/>
                </el-form-item>
                <el-form-item label="岗位：" required>
                  <el-input v-model="employeeData.job_id" placeholder="岗位" clearable/>
                  <!--                  <el-select v-model="employeeData.job_id" placeholder="岗位"  filterable clearable>
                                      <el-option v-for="item in positionOption" :key="item.id" :label="item.field_name" :value="item.field_name"/>
                                    </el-select>-->
                </el-form-item>
                <el-form-item label="职务：">
                  <el-input v-model="employeeData.position_id" placeholder="职务" clearable/>
                  <!--                  <el-select v-model="employeeData.position_id" placeholder="职务"  filterable clearable>
                                      <el-option v-for="item in positionOption" :key="item.id" :label="item.field_name" :value="item.field_name"/>
                                    </el-select>-->
                </el-form-item>
                <el-form-item label="员工类型：" required>
                  <el-select v-model="employeeData.employee_type" placeholder="员工类型" clearable>
                    <el-option v-for="item in employeeTypeList" :key="item.id" :label="item.employee_type_name"
                               :value="item.id"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="手机号码：" required>
                  <el-input v-model="employeeData.phone" placeholder="手机号码"
                            oninput="value=value.replace(/[^\d]/g, '')" clearable/>
                </el-form-item>
                <el-form-item label="企业邮箱：">
                  <el-input v-model="employeeData.email" placeholder="企业邮箱" clearable/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item required>
              <kf-image-upload class="employee-photo" v-model="employeeData.photo" :init-file="employeeData.photo_obj"
                               @fileChange="photoChange" :limit="1"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="人力资源类型：">
              <el-select v-model="employeeData.hr_type" placeholder="间接/直接"  filterable clearable>
                <el-option v-for="item in hrList" :key="item.value" :label="item.name" :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="厂外工龄：">
              <el-input-number style="width: 100%" v-model="employeeData.work_year_out"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="入集团日期：" required>
              <el-date-picker v-model="employeeData.entry_corporation_date" type="date" placeholder="选择日期"
                              value-format="YYYY-MM-DD" style="width: 100%"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入职日期：" required>
              <el-date-picker v-model="employeeData.entry_factory_date" type="date" placeholder="选择日期"
                              value-format="YYYY-MM-DD" style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="隶属厂区：" required>
              <el-select v-model="employeeData.factory_id" placeholder="隶属厂区"  filterable disabled>
                <el-option v-for="item in factoryList" :key="item.id" :label="item.name" :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="隶属公司：" required>
              <el-select v-model="employeeData.company_id" placeholder="隶属公司"  filterable clearable>
                <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="部门：" required>
              <el-cascader v-model="employeeData.all_department_ids" :options="departmentList"
                           :props="mulOptionProps" :show-all-levels="true" style="width: 100%"  @change="initLeaderDept"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="是部门负责人：">
              <div class="switch-group">
                <div
                    v-for="(deptPath, index) in employeeData.all_department_ids"
                    :key="index"
                    class="switch-item"
                >
                  <span class="dept-label">{{ `部门${index + 1}` }}：</span>
                  <el-switch v-model="employeeData.leader_dept[index]" />
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="主部门：" required>
              <el-cascader v-model="employeeData.main_department_id" :options="departmentList"
                           :props="optionProps" :show-all-levels="true" style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">试用期选项:</label>
    <el-card style="margin: 5px">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="试用期选项：">
              <el-switch v-model="employeeData.is_probation" @change="getProbationEndDate"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="试用期：">
              <el-select v-model="employeeData.probation_period_type" placeholder="试用期" clearable>
                <el-option v-for="item in probationList" :key="item.value" :label="item.name" :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="试用期结束日期：">
              <el-date-picker type="date" value-format="YYYY-MM-DD" v-model="employeeData.probation_end_date"
                              placeholder="选择日期" style="width: 100%" clearable/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-row>
      <el-col :span="24" style="text-align: center">
        <el-button type="primary" :loading="loading" @click="saveEmployeeInfo">保存</el-button>
      </el-col>
    </el-row>
  </el-scrollbar>
  <el-dialog v-model="dialogVisible" style="width: 800px;height: 550px;">
    <div class="video-thumbnail">
      <img id="view2" src="http://127.0.0.1:38088/video=stream&camidx=1" alt="副摄像头"
           style="width: 770px;height:450px;">
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="closeCamera">取消</el-button>
        <el-button type="primary" @click="takePhoto">
          拍照
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>

import {Plus} from "@element-plus/icons-vue";
import axios from 'axios'
import moment from "moment/moment";

export default {
  name: "EmployeePhoto",
  components: {Plus},
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  computed: {
    boolList() {
      return this.$store.getters['core/getDictList']('bool');
    },
    hrList(){
      return this.$store.getters['core/getDictList']('hr_type');
    },
    probationList(){
      return this.$store.getters['core/getDictList']('probation_type');
    }
  },
  data() {
    return {
      optionProps: {
        emitPath: false,
        label: "name",
        value: "id",
        checkStrictly: true
      },
      mulOptionProps: {
        emitPath: false,
        label: "name",
        value: "id",
        checkStrictly: true,
        multiple: true
      },
      takePhotoObj: {
        component: 'take_photo',
        limit: 1,
      },
      photoUpload: {
        component: 'image_upload',
        limit: 1,
      },
      employeeData: {
        employee_no: '',
        employee_name: '',
        department_ids: [],
        is_leader:false,
        leader_dept:[],
        position_ids: '',
        position_level: '',
        phone: '',
        email: '',
        photo: '',
        entry_date: '',
        is_probation: false,
        probation_end_date: '',
        labor_company_id:'',
        employee_type:''
      },
      dialogVisible: false,
      departmentList: [],
      positionList: [],
      jobLevelList: [],
      employeeTypeList: [],
      laborCompanyList:[],
      positionOption:[],
      ddTypeOption:[],
      laborOption:[],
      probationOption:[],
      factoryList:[],
      companyList:[],
      loading: false,
      maxRetries: 3,
      retryCount: 0
    }
  },
  methods: {
    async loadEmployeeInfo() {
      let params = {id: this.parentData.id}
      let dbEmployee = await this.$http('employeeInfoService.getEmployeeInfo', params);
      if (dbEmployee) {
        this.employeeData = dbEmployee;
        const deptIds = this.employeeData.all_department_ids || [];
        let leaderFlags = [];
        if (this.employeeData.is_department_leader && Array.isArray(this.employeeData.is_department_leader)) {
          // 按索引一一对应，长度以 deptIds 为准（更安全）
          leaderFlags = deptIds.map((_, index) => {
            const val = this.employeeData.is_department_leader[index];
            return val === "1" || val === true;
          });
        } else {
          // 没有负责人数据，默认全 false
          leaderFlags = new Array(deptIds.length).fill(false);
        }
        this.employeeData.leader_dept = leaderFlags;
      }
    },
    //获取部门列表
    async getDepartmentList() {
      this.departmentList = await this.$http('sysUserDepartmentService.getDepartmentData');
    },
    //获取员工类型
    async getEmployeeType() {
      let params = {modelId: "hr_employee_type"}
      this.employeeTypeList = await this.$http('employeeHRService.getAll', params);
    },
    //获取劳务公司列表
    async getLaborCompany() {
      let params = {modelId: "hr_labor_company"}
      this.laborCompanyList = await this.$http('employeeHRService.getAll',params);
    },
    //获取员工类型
    async getDDTypeOption() {
      let params = {group_id: "sys01-employeeType"}
      this.ddTypeOption = await this.$http('employeeInfoService.getRosterOptionList',params);
      console.log(this.ddTypeOption);
    },
    //获取劳务公司
    async getLaborOption() {
      let params = {group_id: "2fba67c0-c6b2-43d6-89f5-ea531257483a"}
      this.laborOption = await this.$http('employeeInfoService.getRosterOptionList',params);
    },
    //获取试用期
    async getProbationTypeOption() {
      let params = {group_id: "sys01-probationPeriodType"}
      this.probationOption = await this.$http('employeeInfoService.getRosterOptionList',params);
    },
    //获取厂区
    async getFactory() {
      let params = {modelId: "hr_document"}
      this.factoryList = await this.$http('sysFactoryService.getAllFactory', params);
    },
    //获取公司
    async getCompany() {
      let params = {modelId: "hr_document"}
      this.companyList = await this.$http('sysFactoryService.getCompanyByUser', params);
    },
    initLeaderDept(newVal){
      this.employeeData.leader_dept = new Array(newVal.length).fill(false);
    },
    saveEmployeeInfo() {
      if (!this.employeeData.employee_no) {
        this.$message.error("请填写工号");
        return;
      }
      if (!this.employeeData.employee_name) {
        this.$message.error("请填写姓名");
        return;
      }
      if (!this.employeeData.job_id) {
        this.$message.error("请填写岗位");
        return;
      }
      if (!this.employeeData.employee_type) {
        this.$message.error("请填写员工类型");
        return;
      }
      /*      if (!this.employeeData.position_level) {
              this.$message.error("请填写职级");
              return;
            }*/
      if (!this.employeeData.entry_corporation_date) {
        this.$message.error("请填写入集团日期");
        return;
      }
      if (!this.employeeData.entry_factory_date) {
        this.$message.error("请填写入职日期");
        return;
      }
      if (!this.employeeData.company_id) {
        this.$message.error("请选择隶属公司");
        return;
      }
      if (!this.employeeData.phone) {
        this.$message.error("请填手机号码");
        return;
      }
      if (this.employeeData.main_department_id === null) {
        this.$message.error("请填写部门");
        return;
      }
      /*if (!this.employeeData.photo) {
        this.$message.error("请上传照片");
        return;
      }*/
      if (this.employeeData.is_probation){
        if (this.employeeData.probation_end_date == null){
          this.$message.error("请输入试用期结束日期");
          return;
        }
      }
      let params = {
        id: this.parentData.id,
        employeeData: this.employeeData
      }
      this.loading = true;
      this.$http('employeeHRService.saveEmpInfo', params, false).then(() => {
        this.$message.success("保存成功");
        this.$fn.closeWindow();
        this.$fn.search();
        this.loading = false;
      }, errMsg => {
        this.$message.error(errMsg)
        // console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
        this.loading = false;
      })
    },
    //拍照
    async openCamera() {
      this.dialogVisible = true;
      //设置分辨率
      const data = {
        "mode": "0",
        "camidx": "1",
          "width": "1280",
        "height": "720"
      }
      try{
        const image = document.getElementById('view2');
        axios.post("http://127.0.0.1:38088/device=setresolution", JSON.stringify(data)).then(response=>{
          console.log(response.data);
          if(response.data.code === "0"){
            image.src = '';
          }
          image.src = 'http://127.0.0.1:38088/video=stream&camidx=1?1';
        });
      }catch(error){
        this.$message.error("摄像头打开失败"+error.message);
      }
    },
    takePhoto() {
      let params = {
        "filepath": "base64",
        "camidx": "1",
        "ColorMode": "0",
        "quality": "1"
      }
      axios.post("http://127.0.0.1:38088/video=grabimage", JSON.stringify(params)).then(response => {
        if (response) {
          let data = {photo: response.data};
          this.$http('photoService.takePhoto', data, false).then(data => {
            if (data) {
              this.employeeData.photo = data.avatar;
              this.employeeData.photo_obj = [data.file];
              this.dialogVisible = false;
              console.log(this.employeeData.photo_obj);
            }
          }, errMsg => {
            this.$message.error(errMsg)
            console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
          });
        }
      });
    },
    closeCamera() {
      let data = {"camidx": "1"}
      axios.post("http://127.0.0.1:38088/video=close", JSON.stringify(data)).then(() => {
        document.getElementById('view2').src = ''
      });
      this.dialogVisible = false;
    },
    async photoChange(ids) {
      console.log(ids)
      if (ids.length <= 0) {
        this.employeeData.photo = ''
        return
      }
      this.employeeData.photo = ids[0];
    },
    getProbationEndDate(){
      if(this.employeeData.is_probation_checked){
        let endDate = moment().add(6, 'month').toDate();
        this.employeeData.probation_end_date = moment(endDate).format('YYYY-MM-DD');
        console.log(this.employeeData.probation_end_date)
      }else {
        this.employeeData.probation_end_date ='';
      }
    }
  },

  created() {
    this.getDepartmentList();
    this.getEmployeeType();
    this.loadEmployeeInfo();
    this.getLaborCompany();
    this.getDDTypeOption();
    this.getLaborOption();
    this.getProbationTypeOption();
    this.getFactory();
    this.getCompany();
  },
}
</script>

<style lang="less">
.employee-photo {
  .el-upload-list--picture-card {
    --el-upload-list-picture-card-size: 260px;
  }

  .el-upload--picture-card {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 230px;
    height: 270px;
  }
}

.el-upload-list--picture-card {
  --el-upload-list-picture-card-size: 300px;
}

.el-upload--picture-card {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 300px;
  height: 300px;
}

.avatar {
  width: 300px;
  height: 300px;
  display: block;
}

.el-image {
  padding: 0 5px;
  max-width: 180px;
  max-height: 200px;
  width: 100%;
  height: 200px;
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: var(--el-fill-color-light);
  color: var(--el-text-color-secondary);
  font-size: 30px;
}

.image-slot .el-icon {
  font-size: 30px;
}

.video-thumbnail {
  position: relative;
  display: inline-block;
}

.video-thumbnail::before {
  content: "";
  position: absolute;
  top: 5%;
  left: 30%;
  width: 320px; /* 根据需要调整方框的尺寸 */
  height: 400px; /* 根据需要调整方框的尺寸 */
  background-color: rgba(0, 0, 0, 0); /* 黑色半透明背景，根据需要调整 */
  border: 2px solid red; /* 白色边框，根据需要调整 */
  box-sizing: border-box; /* 边框计算在尺寸内 */
}

.switch-group {
  display: flex;
  flex-wrap: wrap;
  gap: 16px; /* 各开关之间的间距 */
  align-items: center;
}

.switch-item {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.dept-label {
  font-size: 14px;
  color: #606266;
}
</style>